import { Button, Flex, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import src from '@/assets/images/success.png';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import s from './SuccessContent.module.scss';

const SuccessContent: React.FC = () => {
  const {
    answerRatingStore: { closeFeedbackModal },
  } = useOrganizationChatAiPageStore();

  return (
    <Flex align="center" className={s.root__content} gap="md" direction="column">
      <img src={src} alt="success image" width={52} height={52} />
      <Text className={s.root__text} size="sm">
        Спасибо за обратную связь! Это поможет нам улучшить качество ответов
      </Text>
      <Button onClick={closeFeedbackModal} className={s.root__footer}>
        Закрыть
      </Button>
    </Flex>
  );
};

export default observer(SuccessContent);
